<template>
  <div>
    <el-dialog title="损耗对象维护" :visible.sync="dialogVisible" width="30%" custom-class="el-dialog ut-dialog-custom"
      @close="resetFields">
      <div style="padding: 0px 30px">
        <el-form :model="formData" :rules="rules" ref="formData" class="el-form add-page">
          <el-form-item label="名称:" prop="name">
            <el-input v-model="formData.name" placeholder="请输入" class="el-input--small--" style="width: 320px" />
          </el-form-item>
          <!-- <el-form-item label="损耗类型:" prop="type">
            <el-select
              v-model="formData.type"
              placeholder="请选择"
              style="width: 320px"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.label"
                class="el-input--small--"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="进线:" prop="enterDevices">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="line('进线')">新增</el-button>
          </el-form-item>
          <div style="padding-left: 100px; min-height: 30px; padding-bottom: 10px">
            <el-tag v-for="tag in formData.enterDevices" :key="tag.id" closable :disable-transitions="false"
              @close="handleInletWire(tag)">
              {{ tag.name }}
            </el-tag>
          </div>
          <el-form-item label="出线:" prop="outDevices">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="line('出线')">新增</el-button>
          </el-form-item>
          <div style="padding-left: 100px">
            <el-tag v-for="tag in formData.outDevices" :key="tag.id" closable :disable-transitions="false"
              @close="handleOutlet(tag)">
              {{ tag.name }}
            </el-tag>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetFields">取 消</el-button>
        <el-button type="primary" @click="submitForm('formData')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="dialogVisibleOne" width="95%" class="u-dialog"
      :close-on-click-modal="false" @close="determine(type == '进线' ? '进线' : '出线')">
      <el-row>
        <el-col :span="5" style="padding-left: 5px; padding-right: 5px">
          <el-card class="box-card devices-area" shadow="never">
            <div slot="header" class="clearfix">
              <span>设备区域</span>
              <el-button style="float: right; padding: 3px 0" type="text" icon="el-icon-refresh"
                @click="refresh">刷新</el-button>
            </div>
            <div style="width: 100%; height: 100%; overflow: auto">
              <el-tree :data="treeData" node-key="lable" ref="tree" :props="defaultProps" :highlight-current="true"
                :expand-on-click-node="false" @node-click="handleNodeClick" class="ut-custom-tree-list"></el-tree>
            </div>
          </el-card>
        </el-col>
        <el-col :span="14" style="padding-left: 5px; padding-right: 5px">
          <el-card class="box-card custom-card" shadow="never">
            <div v-if="tableData.length > 0" slot="header" class="clearfix">
              <span>{{ name ? name : "--" }}</span>
              <el-button style="float: right; padding: 3px 0" type="text" icon="el-icon-refresh">刷新</el-button>
            </div>
            <div v-else slot="header" class="clearfix">
              <span>--</span>
            </div>
            <div v-if="tableData.length > 0" class="custom-crud">
              <el-form :model="formUser" class="el-form add-page table-search-form-single"
                style="padding: 10px 15px 0px 25px">
                <el-form-item label="设备名称/编号" class="form-adaption el-form-item--mini">
                  <el-input v-model="formUser.name" placeholder="请输入" class="el-input--small--" style="width: 200px" />
                </el-form-item>
                <!-- <el-form-item
                  label="设备类型"
                  class="form-adaption el-form-item--mini"
                >
                  <el-cascader
                    :options="optionType"
                    :show-all-levels="false"
                    :props="{
                      multiple: true,
                      checkStrictly: true,
                      expandTrigger: 'hover',
                    }"
                    class="u-input--suffix"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <el-form-item
                  label="是否包含子设备类型"
                  class="form-adaption el-form-item--mini"
                >
                  <el-switch
                    v-model="formUser.subset"
                    active-color="#409eff"
                    inactive-color="#dcdfe6"
                  >
                  </el-switch>
                </el-form-item>
                <el-form-item
                  label="是否包含子区域"
                  class="form-adaption el-form-item--mini"
                >
                  <el-switch
                    v-model="formUser.district"
                    active-color="#409eff"
                    inactive-color="#dcdfe6"
                  >
                  </el-switch>
                </el-form-item> -->
                <el-form-item class="form-adaption el-form-item--mini">
                  <el-button type="primary" size="small" icon="el-icon-search">查询</el-button>
                </el-form-item>
              </el-form>
              <div>
                <el-table ref="multipleTable" :data="
                    tableData.slice(
                      (currentPage - 1) * pageSize,
                      currentPage * pageSize
                    )
                  " style="width: 100%; height: 540px" max-height="540px" :row-key="
                    (row) => {
                      return row.id;
                    }
                  " @selection-change="handleSelectionChange" @select-all="handleSelectAll"
                  @row-click="handleRowClick">
                  <el-table-column type="selection" width="55" :reserve-selection="true" align="center">
                  </el-table-column>
                  <!-- <el-table-column prop="number" label="设备编号" width="256">
                  </el-table-column> -->
                  <el-table-column prop="name" label="设备名称">
                  </el-table-column>
                  <!-- <el-table-column prop="type" label="设备类型" width="256">
                  </el-table-column>
                  <el-table-column prop="describe" label="设备描述">
                  </el-table-column> -->
                </el-table>
              </div>
              <div class="d2-crud custom-crud">
                <div class="d2-crud-pagination">
                  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 30, 50]"
                    layout="total, sizes, prev, pager, next, jumper" :total="tableData.length">
                  </el-pagination>
                </div>
              </div>
            </div>
            <div v-else class="custom-crud d2-card-body">请先选择设备区域</div>
          </el-card>
        </el-col>
        <el-col :span="5" style="padding-left: 5px; padding-right: 5px">
          <el-card class="box-card devices-area" shadow="never">
            <div slot="header" class="clearfix">
              <span>已选择设备({{ facilityData.length }})</span>
              <el-button v-if="facilityData.length > 0" style="float: right; padding: 3px 0; color: #f56c6c" type="text"
                icon="el-icon-delete" @click="facilityDataDel">清空选择</el-button>
            </div>
            <div>
              <el-table :data="facilityData" style="width: 100%" :show-header="false" tooltip-effect="dark"
                row-class-name="el-table--mini">
                <el-table-column prop="name" width="300"> </el-table-column>
                <el-table-column fixed="right" label="操作" width="50" align="center">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="deleteRow(scope.row)" type="text" size="small"
                      icon="el-icon-close" style="color: #f56c6c; padding: 0">
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleOne = false">取 消</el-button>
        <el-button type="primary" @click="determine(type == '进线' ? '进线' : '出线')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      treeData: {
        type: Array,
        default: () => "",
      },
    },
    data () {
      return {
        title: "",
        genre: "", //类型 add为新增 edit为编辑
        name: "",
        type: "",
        dialogVisible: false,
        dialogVisibleOne: false,
        formData: {
          name: "",
          enterDevices: [],
          outDevices: [],
        },
        formUser: {
          name: "",
          subset: false,
          district: false,
        },
        // options: [
        //   {
        //     label: "线路线损",
        //   },
        // ],
        //级联选择器
        optionType: [
          {
            value: "zhinan",
            label: "指南",
            children: [
              {
                value: "shejiyuanze",
                label: "设计原则",
                children: [
                  {
                    value: "yizhi",
                    label: "一致",
                  },
                ],
              },
            ],
          },
        ],
        //设备表格数组
        tableData: [],
        //设备数组
        facilityData: [],
        defaultProps: {
          children: "children",
          label: "label",
        },
        //表单效验
        rules: {
          name: [{required: true,message: "请填写名称",trigger: "blur"}],
          enterDevices: [
            {required: true,message: "请增加进线",trigger: "blur"},
          ],
          outDevices: [
            {required: true,message: "请增加出线",trigger: "blur"},
          ],
        },
        currentPage: 1, //当前页
        pageSize: 10, //每页条数
      };
    },
    computed: {},
    mounted () {},
    methods: {
      //调用组件启动方法
      init (type,data) {
        //表单效验重置
        this.$nextTick(() => {
          this.$refs.formData.resetFields();
        });
        if(type=="add") {
          this.formData={
            name: "",
            enterDevices: [],
            outDevices: [],
          };
        } else {
          this.formData=Object.assign({},data);
        }
        console.log(this.formData);
        this.genre=type;
        this.dialogVisible=true;
      },
      resetFields () {
        this.dialogVisible=false;
      },
      //进线出线确认
      determine (type) {
        if(type=="进线") {
          this.formData.enterDevices=this.facilityData;
        } else {
          this.formData.outDevices=this.facilityData;
        }
        this.dialogVisibleOne=false;
      },
      //表格多选状态
      toggleSelection (rows) {
        console.log(rows);
        if(rows.length>0) {
          this.$nextTick(() => {
            this.$refs.multipleTable.clearSelection();
          });
          rows.forEach((row) => {
            this.$nextTick(() => {
              this.$refs.multipleTable.toggleRowSelection(row,true);
            });
          });
        } else {
          this.$nextTick(() => {
            this.$refs.multipleTable.clearSelection();
          });
        }
      },
      //设备数据清空
      facilityDataDel () {
        this.$confirm("确定清空全部已选设备？","提示",{
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.facilityData.splice(0);
            this.toggleSelection(this.facilityData);
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          })
          .catch(() => {});
      },
      //表格内行删除
      deleteRow (val) {
        this.facilityData.map((v,i) => {
          if(v.id==val.id) {
            this.facilityData.splice(i,1);
          }
        });
        this.$refs.multipleTable.toggleRowSelection(val);
      },
      //每页条数改变时触发 选择一页显示多少行
      handleSizeChange (val) {
        this.currentPage=1;
        this.pageSize=val;
      },
      //当前页改变时触发 跳转其他页
      handleCurrentChange (val) {
        this.currentPage=val;
      },
      //表格多选
      handleSelectionChange (val) {
        this.facilityData=[];
        val.map((item) => {
          this.facilityData.push(item);
        });
      },
      handleSelectAll (val) {
        this.facilityData=[];
        val.map((item) => {
          this.facilityData.push(item);
        });
      },
      handleRowClick (row,column,event) {
        this.$refs.multipleTable.toggleRowSelection(row);
      },
      //设备新增
      line (type) {
        this.type=type;
        if(type=="进线") {
          this.title="请选择设备--请选择进线设备";
          this.facilityData=this.formData.enterDevices;
        } else {
          this.title="请选择设备--请选择出线设备";
          this.facilityData=this.formData.outDevices;
        }
        // this.selected();
        this.dialogVisibleOne=true;
      },
      //多选状态是否有选中
      selected () {
        const {facilityData,tableData}=this;
        console.log(facilityData,tableData);
        if(facilityData.length>0) {
          facilityData.forEach((key) => {
            tableData.forEach((row) => {
              // this.$refs.multipleTable.clearSelection();
              if(row.id==key.id) {
                this.$nextTick(() => {
                  this.$refs.multipleTable.toggleRowSelection(row,true);
                });
              }
            });
          });
        } else {
          this.$nextTick(() => {
            this.$refs.multipleTable.clearSelection();
          });
        }
      },
      //树形监听
      handleNodeClick (data) {
        this.name=data.label;
        this.$api.deviceApi.getReadDeviceByNo(data.no,36,(res) => {
          this.tableData=res;
          this.selected();
        });
      },
      //进线删除
      handleInletWire (tag) {
        this.formData.enterDevices.splice(
          this.formData.enterDevices.indexOf(tag),
          1
        );
      },
      //出线删除
      handleOutlet (tag) {
        this.formData.outDevices.splice(this.formData.outDevices.indexOf(tag),1);
      },
      //表单效验
      submitForm (formName) {
        console.log(this.formData);
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.$emit("append",this.formData,this.genre);
            this.dialogVisible=false;
          } else {
            return false;
          }
        });
      },
      //刷新
      refresh () {
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys([]);
        });
      },
    },
  };
</script>

<style scoped>
  /deep/ .el-dialog__title {
    font-size: 18px;
  }

  .ut-page-list .add-page {
    padding: 20px;
  }

  .el-form-item {
    margin-bottom: 10px;
    display: flex;
  }

  /deep/.el-input--small-- .el-input__inner {
    height: 32px;
    line-height: 32px;
    border-radius: 25px;
    width: 100% !important;
  }

  /deep/.el-dialog__body {
    padding: 0 15px 15px 15px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow: auto;
  }

  /deep/.el-form-item__label {
    width: 100px;
  }

  /deep/.u-input--suffix .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
    width: 200px;
  }

  .el-row {
    background-color: #fff;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 10px 0;
  }

  .el-row:after,
  .el-row:before {
    display: table;
  }

  .u-dialog span {
    font-size: 14px !important;
  }

  /deep/.el-card__header {
    padding: 15px;
  }

  /deep/.devices-area .el-card__body {
    padding: 0;
    height: 680px;
    overflow: auto;
  }

  /deep/.ut-custom-tree-list .el-tree-node__content {
    padding: 8px 0;
    border-radius: 4px;
  }

  /deep/.ut-custom-tree-list {
    margin: 10px;
  }

  /deep/.el-tree-node:focus>.el-tree-node__content {
    background-color: #f5f7fa;
  }

  /deep/.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #f0f7ff;
  }

  /deep/ .custom-card .el-card__body {
    padding: 10px;
  }

  .custom-crud {
    background-color: #fff;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  .table-search-form-single {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  .table-search-form-single .form-adaption {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    margin-right: 15px;
  }

  .ut-page-list .table-search-form-multiple .form-adaption .el-form-item__label,
  .ut-page-list .table-search-form-single .form-adaption .el-form-item__label {
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }

  /deep/.form-adaption .el-form-item__label {
    width: 100% !important;
  }

  /deep/.form-adaption .el-button {
    padding: 3px 20px;
    border-radius: 20px;
  }

  .d2-crud-pagination {
    padding: 15px 15px 0 !important;
  }

  /deep/.el-table--mini td,
  .el-table--mini th {
    padding: 6px 0;
  }

  /deep/.el-table--mini span {
    font-size: 12px;
  }

  .d2-card-body {
    height: 700px;
    font-size: 14px;
  }
</style>